<template>
    <!-- 单选题 -->
    <div class="question-item">
        {{ dataList }}
        <div class="question-item-num">
            <question-title v-if="titleIsEdit" :dataList="dataList" @numberBlur="(e) => emits('numberChange', e)" />
            <div v-else style="margin-top: 8px">{{ dataList.questionNumber }}</div>
        </div>
        <div class="question-item-content">
            <div class="title">
                <rich-text-editor ref="titileInput" class="titile-input" v-model:valueData="dataList.title" />
            </div>
            <div class="content">
                <!-- 文本 -->
                <div v-if="dataList.answerType == '1'" class="input-box" :style="{ height: dataList.inputBoxType == '1' ? '30px' : '94px' }">
                    {{ dataList.placeHolderText }}
                </div>
                <!-- 语音输入 -->
                <div v-else class="voice-entry">
                    <img src="@/images/icon/voice@3x.png" alt="" />
                    <div class="input-box" style="height: ">请按住说话</div>
                </div>
            </div>
            <!-- 底部操作栏 -->
            <div class="footer-operation">
                <action-bar
                    class="action-bar"
                    @addCopy="() => emits('copyQuestion', dataList)"
                    @deleteQuestion="() => emits('deleteQuestion')"
                    @view="(e) => emits('singlePreview', e)"
                >
                </action-bar>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-fill-blank">
// js
import { ref, watch, provide } from "vue";

// components
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import ActionBar from "@/components/action/ActionBar.vue";
import QuestionTitle from "@/components/question/QuestionNumber.vue";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 题号是否可编辑
    titleIsEdit: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
});

// 复制题目，删除题目, 数据改变, 单题预览, 题号改变;
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview", "numberChange"]);

const titileInput = ref(null);

watch(
    () => props.dataList,
    (curr, old) => {
        emits("change", curr);
    },
    { deep: true }
);

provide("data", props.dataList);
defineExpose({ titileInput });
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;

.input-box {
    width: 496px;
    height: 30px;
    line-height: 30px;
    padding-left: 13px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(229, 232, 238, 1);
    font-size: 14px;
    color: rgba(183, 186, 191, 1);
}
.voice-entry {
    display: flex;
    align-items: center;
    img {
        width: 24px;
        height: 24px;
        margin-right: 20px;
    }
}
</style>
